import { Form, Input, Modal } from "antd";
import { useCreateContact } from "../../query/SaleQuery";
import { notify } from "../../utils/toast";

interface ModalAddContactProps {
  open: boolean;
  onCancel: () => void;
  onSuccess: () => void;
}

const ModalAddContact = ({
  open,
  onCancel,
  onSuccess,
}: ModalAddContactProps) => {
  const [form] = Form.useForm();
  const createContact = useCreateContact();

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      await createContact.mutateAsync(values);
      notify.success("Thêm liên hệ thành công");
      form.resetFields();
      onSuccess();
    } catch (error) {
      notify.error("Thêm liên hệ thất bại");
    }
  };

  return (
    <Modal
      title="Thêm liên hệ"
      open={open}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={handleSubmit}
      confirmLoading={createContact.isPending}
      okText="Thêm"
      cancelText="Hủy"
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Tên liên hệ"
          name="name"
          rules={[{ required: true, message: "Vui lòng nhập tên liên hệ" }]}
        >
          <Input placeholder="Nhập tên liên hệ" />
        </Form.Item>

        <Form.Item
          label="Số điện thoại"
          name="phone"
          rules={[{ required: true, message: "Vui lòng nhập số điện thoại" }]}
        >
          <Input placeholder="Nhập số điện thoại" />
        </Form.Item>

        <Form.Item
          label="Chức vụ"
          name="position"
          rules={[{ required: true, message: "Vui lòng nhập chức vụ" }]}
        >
          <Input placeholder="Nhập chức vụ" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalAddContact;
